module.exports = __webpack_public_path__ + "assets/img/bind8.8546c14c.png";